import { render, staticRenderFns } from "./Checklists.vue?vue&type=template&id=06a00bb4&lang=pug&"
import script from "./Checklists.vue?vue&type=script&lang=ts&"
export * from "./Checklists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports